import { CSSProperties } from 'react';

import { ContentState, convertFromHTML } from 'draft-js';

import { getKeys } from './objects';

export const pxToRem = (px: number) => `${px / 16}rem`;
export const remToPx = (rem: string) => parseFloat(rem) * 16;
export const htmlToPlaintext = (html: string) => {
  const blocksFromHTML = convertFromHTML(html);
  const state = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );
  return state.getPlainText();
};

export const styleToString = (style: CSSProperties) => {
  return getKeys(style).reduce(
    (acc, key) =>
      acc +
      key
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase() +
      ':' +
      style[key] +
      ';',
    ''
  );
};
